import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileDelayIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	stroke: "#3C3C3C",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 8V13",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 2H15",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7969 16.832V18.707",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7992 21.4862H15.2742C13.8284 21.4862 13.2242 20.5562 13.9242 19.42L15.2242 17.3125L16.4492 15.3325C17.1909 14.1287 18.4076 14.1287 19.1492 15.3325L20.3742 17.3163L21.6742 19.4238C22.3742 20.56 21.7659 21.49 20.3242 21.49H17.7992V21.4862Z",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7969 19.832H17.8006",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFileDelayIcon;
